"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSearchString = exports.searchFailure = exports.searchSuccess = exports.searchRequest = exports.getByBusinessIdFailure = exports.getByBusinessIdSuccess = exports.getByBusinessIdRequest = exports.clear = void 0;
const ActionTypes = require("../../actionTypes/ytj");
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
const getByBusinessIdRequest = (searchString) => ({
    type: ActionTypes.GET_BY_BUSINESS_ID_REQUEST,
    payload: searchString
});
exports.getByBusinessIdRequest = getByBusinessIdRequest;
const getByBusinessIdSuccess = (companies) => ({
    type: ActionTypes.GET_BY_BUSINESS_ID_SUCCESS,
    payload: companies
});
exports.getByBusinessIdSuccess = getByBusinessIdSuccess;
const getByBusinessIdFailure = (error) => ({
    type: ActionTypes.GET_BY_BUSINESS_ID_FAILURE,
    payload: error
});
exports.getByBusinessIdFailure = getByBusinessIdFailure;
const searchRequest = (searchString) => ({
    type: ActionTypes.SEARCH_REQUEST,
    payload: searchString
});
exports.searchRequest = searchRequest;
const searchSuccess = (companies) => ({
    type: ActionTypes.SEARCH_SUCCESS,
    payload: companies
});
exports.searchSuccess = searchSuccess;
const searchFailure = (error) => ({
    type: ActionTypes.SEARCH_FAILURE,
    payload: error
});
exports.searchFailure = searchFailure;
const setSearchString = (searchString) => ({
    type: ActionTypes.SET_SEARCH_STRING,
    payload: searchString
});
exports.setSearchString = setSearchString;
//# sourceMappingURL=index.js.map